/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Invite_SubtitleInputs */

const cs_auth_invite_subtitle = /** @type {(inputs: Auth_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvolte heslo a dokončete připojení ke kanceláři.`)
};

const en_auth_invite_subtitle = /** @type {(inputs: Auth_Invite_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a password to finish joining your office.`)
};

/**
* | output |
* | --- |
* | "Choose a password to finish joining your office." |
*
* @param {Auth_Invite_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_invite_subtitle = /** @type {((inputs?: Auth_Invite_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Invite_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_invite_subtitle(inputs)
	return cs_auth_invite_subtitle(inputs)
});